import {post} from '../utils/request'

export default {
    getByUserId(userId) {
        return post("/admin/address/getByUserId", {userId});
    },
    update(address) {
        return post("/admin/address/update", address);
    },
    add: function(address, userId) {
        return post("/admin/address/add", { ...address, userId })
    }
}
